var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmpresasHome"},[(!_vm.sesion)?_c('EmpresasHomeNoLogin'):_c('EmpresasHomeSeleccionar'),(!_vm.sesion)?_c('div',{staticClass:"technical-drawing__section empresas-login"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }